/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

function DataTableBodyCell({ noBorder, align, children, rowSpan }) {
  const cellProps = rowSpan > 1 ? { rowSpan } : {};
  // console.log("rowSpan", rowSpan);
  return (
    <MDBox
      component="td"
      textAlign={align}
      py={1.5}
      px={3}
      {...cellProps}
      sx={({ palette: { light }, typography: { size }, borders: { borderWidth } }) => ({
        fontSize: size.sm,
        borderBottom: noBorder || rowSpan > 1 ? "none !important" : `${borderWidth[1]} solid ${light.main}`,
        borderTop: 'none !important',
        borderLeft: 'none !important',
        borderRight: 'none !important',
        verticalAlign: rowSpan > 1 ? 'middle !important' : 'inherit',
      })}
    >
      <MDBox
        display={rowSpan > 1 ? "flex" : "inline-block"}
        alignItems={rowSpan > 1 ? "center" : "initial"}
        justifyContent={rowSpan > 1 ? "center" : "initial"}
        width={rowSpan > 1 ? "100%" : "max-content"}
        height={rowSpan > 1 ? "100%" : "auto"}
        color="text"
        sx={{ verticalAlign: "middle" }}
      >
        {children}
      </MDBox>
    </MDBox>
  );
}

// Setting default values for the props of DataTableBodyCell
DataTableBodyCell.defaultProps = {
  noBorder: false,
  align: "left",
  rowSpan: 1,
};

// Typechecking props for the DataTableBodyCell
DataTableBodyCell.propTypes = {
  children: PropTypes.node.isRequired,
  noBorder: PropTypes.bool,
  align: PropTypes.oneOf(["left", "right", "center"]),
  rowSpan: PropTypes.number,
};

export default DataTableBodyCell;
